var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "#000",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.25 15.75H.75v1.5c0 .414.336.75.75.75h3a.75.75 0 0 0 .75-.75v-1.5zm12 0h-4.5v1.5c0 .414.336.75.75.75h3a.75.75 0 0 0 .75-.75v-1.5zm.09-7.72-.905-.905-1.192-5.362A2.237 2.237 0 0 0 13.05 0h-8.1a2.237 2.237 0 0 0-2.193 1.763L1.565 7.125.66 8.03C.236 8.451 0 9.024 0 9.621V13.5c0 .414.336.75.75.75h16.5a.75.75 0 0 0 .75-.75V9.621a2.234 2.234 0 0 0-.66-1.59zM4.222 2.087A.746.746 0 0 1 4.95 1.5h8.1a.746.746 0 0 1 .732.587l1.034 4.663H3.185L4.22 2.087zM3.375 12a1.125 1.125 0 1 1 0-2.25 1.125 1.125 0 0 1 0 2.25zm11.25 0a1.125 1.125 0 1 1 0-2.25 1.125 1.125 0 0 1 0 2.25z",
    fill: "inherit",
    fillRule: "evenodd"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCar);
export default __webpack_public_path__ + "static/media/car.8dd4eb0dda3b903da67732117b4e12d1.svg";
export { ForwardRef as ReactComponent };